export default "__VITE_ASSET__DE_rnE0x__"